import * as $ from "jquery";
    export class ToggleMenuDirective implements ng.IDirective {
        public restrict = 'C';
        public link = ($scope: any, $elem: ng.IAugmentedJQuery) => {

            var toggleMenu = 'notification-menu';
            function closeglobalNav() {
                if ($('.' + toggleMenu).hasClass('active')) {
                    $('.' + toggleMenu).removeClass('active');
                }
            }

            console.log('TEST');

            $(document).click(event => {
                if (!$(event.target).closest('.' + toggleMenu).length && !$(event.target).closest($elem).length) {
                    closeglobalNav();
                }
            });

            $('.' + toggleMenu + ' a').click(() => {
                closeglobalNav();
            });

            $elem.click(() => {
                console.log('CLICKED');
                if ($('.' + toggleMenu).hasClass('active')) {
                    closeglobalNav();
                } else {
                    $('.' + toggleMenu).addClass('active');
                }
            });
        }
    }
